import { Resource as t, API as a } from "@coveo/platform-client";
const e = class e extends t {
  getFieldValues(s) {
    return this.api.post(`${e.baseUrl}/field/values`, s);
  }
};
e.baseUrl = `/rest/organizations/${a.orgPlaceholder}/commerce/private/catalog`;
let r = e;
export {
  r as CatalogFields
};
//# sourceMappingURL=CatalogFields.js.map
